import { AMEND_ORDER_SERVICE, IAmendOrderService } from '../amend-order';
import { BLOTTER_SERVICE, IBlotterService } from '../blotter';
import { filter, map, pluck, skip, withLatestFrom } from 'rxjs/operators';
import { IAmendOrderFromAnotherUserService } from './amend-order-from-another-user.interface';
import { inject, injectable, named } from 'inversify';
import { IPendingOrderReport } from '../../interfaces';
import { Observable } from 'rxjs';

@injectable()
export class AmendOrderFromAnotherUserService implements IAmendOrderFromAnotherUserService {

    @inject(BLOTTER_SERVICE)
    @named('pending')
    private readonly blotterSrv: IBlotterService;

    @inject(AMEND_ORDER_SERVICE)
    private readonly amendOrderSrv: IAmendOrderService;

    asObservable(): Observable<IPendingOrderReport> {
        return this.blotterSrv.ordersObservable()
            .pipe(
                skip(1),
                pluck('updated'),
                withLatestFrom(this.amendOrderSrv.asObservable()),
                filter(([ , amendingOrder ]) => Boolean(amendingOrder)),
                map(([ updatedOrders, amendingOrder ]) => {
                    const updatedOrder = updatedOrders
                        .find(item => item.orderId === amendingOrder.orderId);

                    // NOTE: A merge between the amended order and the updated one
                    // is needed because the back don't send us all the info about
                    // the order.
                    return Boolean(updatedOrder) ?
                        {
                            ...amendingOrder,
                            ...updatedOrder,
                        } :
                        undefined;
                }),
                filter(Boolean),
                map(item => item as IPendingOrderReport),
            );
    }
}
